<template>
  <LcBadge v-bind="CONFIG[status]">
    {{ $t(`myorders.status.highfrequency.${status}`) }}
  </LcBadge>
</template>

<script lang="ts" setup>
import type { LcIconName } from '@lottocom/frontend-components'

import { HighFrequency_OrderStatus } from '#api/shared/@types/generated/backend/graphql-schema-types'

import { HighFrequency_OrderStatusActive } from '../utils/types'

type MyOrdersStatusBadgeHighFrequencyProps = {
  count?: number
  status: HighFrequency_OrderStatus | HighFrequency_OrderStatusActive
}

type StatusBadge = {
  class: string
  count?: number
  icon: LcIconName
}

const { count } = defineProps<MyOrdersStatusBadgeHighFrequencyProps>()

const CONFIG = computed<
  Partial<Record<HighFrequency_OrderStatus | HighFrequency_OrderStatusActive, StatusBadge>>
>(() => ({
  [HighFrequency_OrderStatus.Cancelled]: {
    class: 'bg-accent-danger-danger',
    icon: 'orders-canceled',
  },
  [HighFrequency_OrderStatus.Finished]: {
    class: 'bg-accent-danger-danger',
    icon: 'orders-purchased',
  },
  [HighFrequency_OrderStatus.Ordered]: {
    class: 'bg-secondary-secondary-bold',
    icon: 'orders-waiting-for-purchase',
  },
  [HighFrequency_OrderStatus.Printed]: {
    class: 'bg-accent-info-info-light',
    icon: 'orders-purchased',
  },
  [HighFrequency_OrderStatusActive.Pending]: {
    class: 'bg-secondary-secondary-bold',
    icon: 'time-pending',
  },
  [HighFrequency_OrderStatusActive.Ready]: {
    class: 'bg-secondary-secondary-bold',
    count,
    icon: 'play',
  },
}))
</script>
